import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BtnGoBack from "../../../components/common/btnGoBack";
import Loadding from "../../../components/common/loadding";
import Doc3GenPdf from "../../../components/report/reportDoc3/doc3GenPdf";
import CourseListForSend from "../../../components/send/doc3/courseListForSend";
import HeadderSend from "../../../components/send/headderSend";
import curriculumService from "../../../services/curriculum.service";
import doc3Service from "../../../services/doc3.service";
import settingScheduleService from "../../../services/settingSchedule.service";
type paramType = {
  scheId: string;
  curriId: string;
};

const SendDoc3 = () => {
  const params = useParams<paramType>();
  const [curri, setCurri] = useState<any>({});
  const [status, setStatus] = useState(true);

  useEffect(() => {
    (async () => {
      await curriculumService.getById(Number(params.curriId)).then((res) => {
        setCurri(res.data);
        setStatus(false);
      });
    })();
  }, []);

  const [setSend, setSetSend] = useState(0);
  ///เพื่อให้รู้ว่าต้องส่งกี่วิชา
  useEffect(() => {
    (async () => {
      settingScheduleService.countCourse(Number(params.scheId)).then((res) => {
        if (res.data.length > 0) {
          setSetSend(
            res.data.filter((x: any) => x.course.owner.id === curri.id).length
          );
        }
      });
    })();
  }, [curri]);

  // Number(curri.id);
  // Number(params.scheId)
  const [countSend, setCountSend] = useState(0);
  useEffect(() => {
    (async () => {
      doc3Service
        .countSend(Number(curri.id), Number(params.scheId))
        .then((res) => {
          // setCountSend(res.data.length);
          setCountSend(res.data.length);
        });
    })();
  }, [curri]);

  if (status) {
    return <Loadding />;
  }
  return (
    <HeadderSend scheId={params.scheId}>
      <div className="alert alert-light text-dark" role="alert">
        <div className="row">
          <div className="col">
            <h5 className="text-start">
              หลักสูตร {curri.shortName} - {curri.name} ({curri.level})
            </h5>
          </div>
          <hr />
          <h6 className="text-start">รายวิชาที่ต้องส่งเอกสาร</h6>
          <CourseListForSend curri={curri} />
          <div className="text-center">
            {/* สรุปรายวิชาที่ต้องส่งทั้งหมด{" "}
            <CountCourse schedule={params.scheId} curri={curri} /> ส่งแล้ว {5} */}
            {/* ตรงนี้ต้องมีเงื่อนไข ต้องรู้ว่าต้องส่งกี่วิชา และต้องรู้ว่าส่งแล้วกี่วิชา ถ้าเท่ากันแสดงข้อมูล */}
            {setSend === countSend && setSend !== 0 ? (
              <Doc3GenPdf
                sche={Number(params.scheId)}
                curri={Number(curri.id)}
                type={curri.type}
              />
            ) : (
              <></>
            )}
          </div>
        </div>
        <BtnGoBack />
      </div>
    </HeadderSend>
  );
};

export default SendDoc3;
